import React, { Component } from 'react';

export default class Sitemap extends Component {
  render() {
    const categories = [
      { id: 130, name: '3D EMBOSSED' },
      { id: 107, name: '3D FLOWER' },
      { id: 67, name: 'ALLOVER' },
      { id: 81, name: 'ANIMALS' },
      { id: 87, name: 'BELT' },
      { id: 74, name: 'BIRD' },
      { id: 85, name: 'BIRDS' },
      { id: 65, name: 'BLOUSE' },
      { id: 68, name: 'BOATNECK' },
      { id: 71, name: 'BRIDAL' },
      { id: 127, name: 'BUNCH' },
      { id: 63, name: 'BUTI' },
      { id: 96, name: 'BUTTERFLY' },
      { id: 115, name: 'CARTOON' },
      { id: 137, name: 'COLLAR' },
      { id: 112, name: 'COW' },
      { id: 75, name: 'CROSS STITCH' },
      { id: 76, name: 'CUT WORK' },
      { id: 124, name: 'DEER' },
      { id: 147, name: 'DIFFERENT FRONT' },
      { id: 110, name: 'DRESS' },
      { id: 88, name: 'ELEPHANT' },
      { id: 119, name: 'FISH' },
      { id: 79, name: 'FLOWER' },
      { id: 89, name: 'FRONT COAT' },
      { id: 145, name: 'GENTS' },
      { id: 90, name: 'GOD' },
      { id: 133, name: 'HAND CHECKS & CROSS LINES' },
      { id: 132, name: 'HAND LINES' },
      { id: 91, name: 'HUMAN FIGURES' },
      { id: 92, name: 'INSTRUMENTS' },
      { id: 93, name: 'JEWELS' },
      { id: 64, name: 'KIDS NECK' },
      { id: 78, name: 'KNOT' },
      { id: 98, name: 'KURTIS' },
      { id: 69, name: 'KUTCHWORK' },
      { id: 146, name: 'LATKAN' },
      { id: 82, name: 'LEAVES' },
      { id: 105, name: 'LION' },
      { id: 86, name: 'LOTUS' },
      { id: 103, name: 'Maggam Buties' },
      { id: 83, name: 'MANGO' },
      { id: 70, name: 'MIRROR' },
      { id: 140, name: 'MOTIF' },
      { id: 142, name: 'NET BORDER DESIGNS' },
      { id: 118, name: 'OFFER DESIGNS' },
      { id: 99, name: 'ONE SIDE' },
      { id: 77, name: 'OTHERS' },
      { id: 143, name: 'PARROT' },
      { id: 84, name: 'PEACOCK' },
      { id: 116, name: 'PEACOCK FEATHER' },
      { id: 100, name: 'PINEAPPLE' },
      { id: 122, name: 'POOLA JADA' },
      { id: 128, name: 'POT' },
      { id: 66, name: 'POTNECK' },
      { id: 94, name: 'RANGOLI' },
      { id: 95, name: 'ROSE' },
      { id: 97, name: 'SAREE PALLU BORDERS' },
      { id: 72, name: 'SIMPLE' },
      { id: 109, name: 'TEMPLE' },
      { id: 111, name: 'TIGER' },
      { id: 139, name: 'TREE' },
      { id: 134, name: 'V-NECK' },
    ];

    return (
      <div
        style={{
          background: 'linear-gradient(135deg, #fff8f2, #fde9e0)',
          padding: '40px 20px',
          fontFamily: 'Arial, sans-serif',
          minHeight: '100vh',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#333',
            fontSize: '32px',
            fontWeight: 'bold',
          }}
        >
          Site Map
        </h1>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '30px',
          }}
        >
          {/* Categories */}
          <div>
            <h2 style={sectionTitleStyle}>Categories</h2>
            <ul style={listStyle}>
              {categories.map((cat) => (
                <li key={cat.id}>
                  <a href={`/category?subcategoryId=${cat.id}&page=1`} style={linkStyle}>
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Special Offers */}
          <div>
            <h2 style={sectionTitleStyle}>Special Offers</h2>
            <ul style={listStyle}>
              <li><a href="/category?subcategoryId=175&page=1" style={linkStyle}>Offer Designs</a></li>
            </ul>
          </div>

          {/* My Account */}
          <div>
            <h2 style={sectionTitleStyle}>My Account</h2>
            <ul style={listStyle}>
              <li><a href="/account/view" style={linkStyle}>Dashboard</a></li>
              <li><a href="/account/profile" style={linkStyle}>Account Information</a></li>
              <li><a href="/account/address" style={linkStyle}>Address Book</a></li>
              <li><a href="/account/order/list" style={linkStyle}>Downloads</a></li>
              <li><a href="/account/wishlist" style={linkStyle}>Wishlist</a></li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h2 style={sectionTitleStyle}>Information</h2>
            <ul style={listStyle}>
              <li><a href="/about-us" style={linkStyle}>About Us</a></li>
              <li><a href="/privacy-policy" style={linkStyle}>Privacy Policy</a></li>
              <li><a href="/terms-and-conditions" style={linkStyle}>Terms & Conditions</a></li>
              <li><a href="/returnsandcancellation" style={linkStyle}>Returns & Cancellation</a></li>
              <li><a href="/pricing" style={linkStyle}>Pricing</a></li>
              <li><a href="/contact-us" style={linkStyle}>Contact Us</a></li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const sectionTitleStyle = {
  fontSize: '20px',
  fontWeight: '600',
  color: '#b0452b',
  marginBottom: '10px',
};

const listStyle = {
  listStyleType: 'disc',
  paddingLeft: '20px',
  lineHeight: '1.8',
  color: '#444',
  fontSize: '15px',
};

const linkStyle = {
  color: '#444',
  textDecoration: 'none',
  transition: 'color 0.3s',
};
